import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Route, Routes } from '@angular/router';
import { FormatoArquivo } from '@core/enums/formato-arquivo.enum';
import { TipoPerfil } from '@core/enums/perfil.enum';
import { ArquivoService } from '@core/services/arquivo.service';
import { StorageService } from "@core/services/storage.service";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver';
import html2canvas from 'html2canvas';
import * as moment from 'moment';
import { ErrorMessage } from 'src/app/core/models/error-message.model';
import { environment } from 'src/environments/environment';
import { FilterStateService } from '../services/filter-state.service';
import { EnumBaseType } from '../types/enum-base.type';

const NAME_PROJECT  = environment.namespaceProject;

export class Util {

  static readonly daysOfWeek = [ 'Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];

  /**
   * Função para setar os errors da requisição conforme de acordo com os seus tipos
   * @param errorMessage Objeto utilizado para incluir os erros
   * @param error Objeto que vem o HttpErroResponse
   * @param typeErr String para setar qual o tipo de error ex: danger, success, warning, info
   * @param errorCustom Boolean para caso queira inserir uma mensagem sem ser pelo tipo do erro da requisição
   */
  static setErrorMessage(
    errorMessage: ErrorMessage,
    error,
    typeErr = 'danger',
    errorCustom = false
  ) {
    if (errorCustom) {
      errorMessage.errorType = typeErr;
      errorMessage.existError = true;
      errorMessage.errorList = this.setErrorList(error);
    }

    if (!errorCustom && error.status === 400) {
      errorMessage.errorType = typeErr;
      errorMessage.existError = true;
      errorMessage.errorList = this.setErrorList(error);
    }

    if (!errorCustom && error.status === 403) {
      errorMessage.errorType = 'warning';
      errorMessage.existError = true;
      errorMessage.errorList.push('Usuário não tem permissão de acesso!');
    }

    if ((!errorCustom && error.status === 0) || error.status === 404) {
      errorMessage.errorType = 'warning';
      errorMessage.existError = true;
      errorMessage.errorList.push(
        'Oopss ocorreu um erro ao processar o seu pedido, não conseguimos conectar com os nossos serviços, por favor tente novamente!'
      );
    }

    setTimeout(() => {
      this.clearErrorMessage(errorMessage);
    }, 10000);
  }

  static setErrorMessageCustom(
    errorMessage: ErrorMessage,
    error: any,
    typeErr = 'danger',
    timeoutClearMessage = 30000
  ) {
    errorMessage.errorType = typeErr;
    errorMessage.existError = true;
    errorMessage.errorList = this.setErrorListCustom(error);

    setTimeout(() => {
      this.clearErrorMessage(errorMessage);
    }, timeoutClearMessage);
  }

  /**
   * Função para Limpar Objeto utilizado para incluir os erros
   * @param errorMessage Objeto utilizado para incluir os erros
   */
  static clearErrorMessage(errorMessage: ErrorMessage) {
    errorMessage.errorType = '';
    errorMessage.existError = false;
    errorMessage.errorList = [];
  }

  /**
   * Função utilizada para setar os errors na lista de acordo com a requisição
   * @param error Objeto que vem o HttpErroResponse
   */
  static setErrorList(error) {
    let list = [];
    Array.isArray(error.error.errors)
      ? (list = error.error.errors)
      : list.push(error.error.errors);
    return list;
  }

  /**
   * Função utilizada para setar os errors na lista custumizada de acordo com a requisição
   * @param error Objeto que vem o HttpErroResponse
   */
  static setErrorListCustom(error) {
    let list = [];
    Array.isArray(error) ? (list = error) : list.push(error);
    return list;
  }

  /**
   * Função para alterar o valor do botão de Buscar
   * @param buttonSubmitConfig Objeto para configuração do botão
   * @param isResp Controle a submissão do botão
   */
  static setBtnFilterReq(buttonSubmitConfig?, isResp = false) {
    if (buttonSubmitConfig) {
      buttonSubmitConfig.buttonText = !isResp ? 'Buscando' : 'Buscar';
      buttonSubmitConfig.buttonSubmited = !isResp;
    }
  }

  /**
   * Função para alterar o valor do botão de Submissão
   * @param buttonSubmitConfig Objeto para configuração do submissão
   * * @param isResp Controle a submissão do botão
   */
  static setBtnSubmitReq(buttonSubmitConfig?, isResp = false) {
    if (buttonSubmitConfig) {
      buttonSubmitConfig.buttonText = !isResp ? 'Salvando' : 'Salvar';
      buttonSubmitConfig.buttonSubmited = !isResp;
    }
  }

  /**
   * Função para alterar o valor do botão de Submissão
   * @param buttonSubmitConfig Objeto para configuração do submissão
   * * @param isResp Controle a submissão do botão
   */
  static setBtnSubmitReqCustom(
    buttonSubmitConfig?,
    isResp = false,
    desc1 = '',
    desc2 = ''
  ) {
    if (buttonSubmitConfig) {
      buttonSubmitConfig.buttonText = !isResp ? desc2 : desc1;
      buttonSubmitConfig.buttonSubmited = !isResp;
    }
  }
  /**
   * Metodo para pegar o nome para a tela (cadastrar/editar)
   * @param id Identificador
   * @param detalhes Bolean para informar se a tela é de detalhes
   */
  static getScreenName(id?: string, detalhes = false) {
    return !id || !id.trim()
      ? 'ADICIONAR'
      : id && !detalhes
      ? 'EDITAR'
      : 'VISUALIZAR';
  }

  /**
   * Função para setar a classe de errro no campo
   * @param formGroup FormGroup do parametro
   * @param messageDisplay Mensagem a ser exibida
   * @param field Campo que receberá a mensagem de validação
   */
  static setErrorsValidate(
    formGroup: FormGroup,
    messageDisplay,
    field: string
  ) {
    if (messageDisplay[field]) {
      return 'is-invalid';
    }
  }

  /**
   * Função para preencher os valores pelo ID
   * @param resp variavel que vem os dados da requisição
   * @param formGroup variavel que traz o form group
   */
  static patchValueForm(obj: any, formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      if (obj[key]) {
        formGroup.controls[key].patchValue(obj[key]);
      }
    });
  }

  /**
   * Adiciona na URL o parametro de "Ativo" com o valor "true"
   */
  static createFilterStatusActive() {
    const params: URLSearchParams = new URLSearchParams();
    params.append('ativo', 'true');

    return params;
  }

  /**
   * Retorna as URL Search Params utilizadas nas requisições
   */
  static createFilter() {
    const params: URLSearchParams = new URLSearchParams();
    return params;
  }

  /**
   * Remove os acentos da string
   * @param str string para ser removida os acentos
   */
  static removeAccents(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  /**
   * Limpa todos os campo do form
   * @param formGroup O form a ser limpo os campos
   */
  static clearFields(formGroup: FormGroup | FormArray) {
    Object.keys(formGroup.controls).forEach((campo) => {
      const control = formGroup.get(campo);
      if (control instanceof FormGroup || control instanceof FormControl) {
        if (control instanceof FormGroup) {
          this.clearFields(control);
        } else {
          if (Array.isArray(control.value)) {
            control.setValue([]);
          } else {
            control.setValue('');
          }
        }
      } else if (control instanceof FormArray) {
        control.controls.splice(0);
        control.updateValueAndValidity();
      }
    });
    formGroup.updateValueAndValidity();
  }

  /**
   * Cria as query params do filtro de busca
   * @param param Objero a ser convertido em parametros
   */
  static getQueryParams(param: object) {
    const params: URLSearchParams = Util.createFilter();

    Object.keys(param).forEach((campo) => {
      const item = param[campo];
      if (item) {
        params.append(campo, item);
      }
    });

    return params;
  }

  /**
   * Obtem os campos invalidos do form
   * @param form Form a ser verificado
   */
  static catchFieldsInvalids(form: FormGroup | FormArray): string[] {
    const invalidControls: string[] = [];

    const recursiveFunc = (formGP: FormGroup | FormArray) => {
      Object.keys(formGP.controls).forEach((field) => {
        const control = formGP.get(field);
        if (control instanceof FormGroup) {
          recursiveFunc(control);
        } else if (control instanceof FormArray) {
          recursiveFunc(control);
        } else {
          if (control.invalid) {
            invalidControls.push(field);
          }
        }
      });
    };
    recursiveFunc(form);
    return invalidControls;
  }

  /**
   * * Abre o modal no tamanho
   * @param modalService Serviço do modal
   * @param component O componente a ser aberto
   * @param size O tamanho do modal (lg, xl, sm) / Valor defaul md
   */
  static openModal(
    modalService: NgbModal,
    component: any,
    size: string = 'md'
  ) {
    const modalRef = modalService.open(component, {
      backdrop: 'static',
      size,
      keyboard: false,
      windowClass: 'modal-custom-' + size,
    });

    return modalRef;
  }

  /**
   * Convert o arquivo de base64 em BlobData
   * @param base64Data Arquivo em Base64
   * @param contentType Tipo do content type
   * @param sliceSize Tamanhp do arquivo
   */
  static convertBase64ToBlobData(
    base64Data: string,
    contentType: string = 'image/png',
    sliceSize = 512
  ) {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }

  static distinct(myArr, prop): any[] {
    return myArr.filter((obj, pos, arr) => {
      return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  }

  static getPerfilSession() {
    return new StorageService().getFromLocalStorage('perfil', true);
  }

  static getUsuarioSession() {
    return new StorageService().getFromLocalStorage('usuario', true);
  }

  static isUserAdmin(): boolean {
    const perfil = this.getPerfilSession();

    return perfil?.toUpperCase() === TipoPerfil.ADM;
  }

  static isUserSeect(): boolean {
    const perfil = this.getPerfilSession();
    return perfil?.toUpperCase() === TipoPerfil.SEECT;
  }

  static isUserProfessor(): boolean {
    const perfil = this.getPerfilSession();
    return perfil?.toUpperCase() === TipoPerfil.PROFESSOR;
  }

  static getListYear(): any[] {
    const yearToday = new Date().getFullYear();
    const range = [];
    range.push(yearToday);
    for (let i = 1; i < 12; i++) {
      range.push(yearToday - i);
    }
    return range;
  }

  // 2022-03-16T17:39:34.185889
  static formatDateHours(date?: string): string {
    if (date) {
      const ano = date.substring(0, 4);
      const mes = date.substring(5, 7);
      const dia = date.substring(8, 10);

      const newDate = new Date(date);

      const horas = newDate.getHours();
      const minutos = newDate.getMinutes();

      return dia + '/' + mes + '/' + ano  + ' às ' + Util.formatNumberDate(horas) + ':' + Util.formatNumberDate(minutos);
    }
  }

  static formatDate(date?: string): string {
    if (date) {
      const ano = date.substring(0, 4);
      const mes = date.substring(5, 7);
      const dia = date.substring(8, 10);

      return dia + '/' + mes + '/' + ano;
    }
  }

  static formatNumberDate(numberDate: number){
    return numberDate < 10 ? ('0' + numberDate) : numberDate;
  }


  /**
   * Função que retorna um string com o formato 'YYYY-MM-DD'
   * @param date data a ser convertida para o formato do form
   */

  static formatDateToInputFormat(date: string) {
    return moment(date).format('YYYY-MM-DD');
  }

  /**
   * Função que converte uma string com o formato 'YYYY-MM-DD' em uma data
   * @param date data em string a ser convertida para o formato de data
   */

  static formatStringToDate(date: string) {
    return date && new Date(
      Number(date.slice(0, 4)),
      Number(date.slice(5, 7)) - 1,
      Number(date.slice(8, 10))
    );
  }

  static getAnos(): Array<any> {
    const anosList = [];

    for (let ano = 2012; ano <= 2012 + 11; ano++) {
      anosList.push({
        name: ano,
        value: ano,
      });
    }

    return anosList;
  }

  static getHorarios(): Array<any> {
    const horariosList = [];

    for (let hora = 0; hora < 24; hora++) {
      for (let minutos = 0; minutos < 56; minutos += 5) {
        const data = moment();
        data.hour(hora);
        data.minute(minutos);

        horariosList.push({
          name: data.format('HH:mm'),
          value: data.format('HH:mm'),
        });
      }
    }
    return horariosList;
  }

  static validateAllFormFields(formGroup: any, ignoreControls: string[] = []) {
    Object.keys(formGroup.controls).forEach(field => {
        const control = formGroup.get(field);
        if (ignoreControls.includes(field)) {
          return;
        }

        if (control instanceof FormControl) {
          control.markAsTouched({ onlySelf: true });
        } else if (control instanceof FormGroup) {
          this.validateAllFormFields(control);
        } else if (control instanceof FormArray) {
          this.validateAllFormFields(control);
        }
    });

    return formGroup.valid;
  }

  static sortRoutes(rotas: Routes) {
    return rotas.sort((a: Route, b: Route) => {
      if (a.path > b.path) {
        return 1;
      } else if (a.path < b.path) {
        return -1;
      } else {
        return 0;
      }
    });
  }

  static sortList(list: any[], attr = 'name') {
    return list.sort((a: Route, b: Route) => {
      if (a?.[attr] > b?.[attr]) {
        return 1;
      } else if (a?.[attr] < b?.[attr]) {
        return -1;
      } else {
        return 0;
      }
    });
  }

  static alertaAlterarFrequenciasDosEstudantes() {
    const errors: ErrorMessage = new ErrorMessage();

    errors.errorType = 'danger';
    errors.existError = true;
    errors.errorList = [ `Não é possível realizar alterações nos campos, pois há registro de avaliação relacionado a este registro. Portanto, só será possível alterar as frequências dos estudantes.`];

    return errors;
  }

  static convertEnumToArray(enumType): EnumBaseType[] {
    return Object.entries(enumType).map(
      ([value, name]: [string, string]) => ({
        name,
        value,
      })
    );
  }

  static getBrasilLocales(): any {
    return {
      firstDayOfWeek: 0,
      dayNames: [
        'Domingo',
        'Segunda',
        'Terça',
        'Quarta',
        'Quinta',
        'Sexta',
        'Sábado',
      ],
      dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
      monthNames: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
      monthNamesShort: [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez',
      ],
      today: 'Hoje',
      clear: 'Limpar',
      weekHeader: 'Semana',
    };
  }

  static patchSavedFilter(filterStateService: FilterStateService, crudKey: string, form: FormGroup, ignoreControls?: string[]): void {
    const savedFilters = filterStateService.getFilter(crudKey);
    if (savedFilters) {
      Object.keys(form.controls).forEach((key) => {
        if (!ignoreControls?.includes(key)) {
          if (savedFilters[key] !== undefined) {
            form.get(key).patchValue(savedFilters[key]);
          }
        }
      });
    }
  }

  static replaceLast(value: string, seachValue: string, replaceValue: string): string {
    const index = value.lastIndexOf(seachValue);
    if (index === -1) {
      return value;
    }
    return value.slice(0, index) + replaceValue + value.slice(index + seachValue.length);
  }

  static replacePlaceholders(template: string, values: string[]): string {
    return template.replace(/\[\d+\]/g, (placeholder) => {
      const newValue =  values[0] ?? placeholder;
      values = values.slice(1);
      return newValue;
    });
  }

  static orderList(list: any[], columnName: string, order: boolean): { list: any[], order: boolean, sortOrder: 'asc' | 'desc' } {
    list.sort((a, b) => {
      let valueA = a[columnName];
      let valueB = b[columnName];
      if (typeof valueA === 'string') {
        valueA = valueA?.toString().trim().toLowerCase();
        valueB = valueB?.toString().trim().toLowerCase();
      }
      if (order) {
        return valueA > valueB ? 1 : -1;
      } else {
        return valueA < valueB ? 1 : -1;
      }
    });

    const sortOrder = order ? 'asc' : 'desc';
    return {
      list, order, sortOrder
    };
  }

  static equalDayMonthYear(date1: Date, date2: Date) {
    return date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate();
  }

  static ordenarEventos(eventos: any[]) {
    return eventos?.sort((a, b) => {
      if (a.nome === 'Dia Letivo') {
        return 1;
      }
      if (b.nome === 'Dia Letivo') {
        return -1;
      }
      return 0;
    });
  }

  /**
   * Formata email e o nome, se não tiver nenhum registro exibe hífen,
   * se tiver apenas um, exibe apenas ele
   * se tiver dois, exibe os nomes/emails separados por 'e', exemplo: joão e maria
   * se tiver mais que dois, exibe separado por vírgula e no final 'e', exemplo: joão, maria e junior
   * @param dado a ser formatado
   * @returns dado formatado
   */
  static formatarEmailENome(dado: any[]) {
    if (!Array.isArray(dado) || !dado.some(element => element && element.trim() !== '')) {
      return '-';
    }
    const dados = dado.filter(element => typeof element === 'string' && element.trim() !== '');

    if (dados.length === 0) {
      return '-';
    }

    if (dados.length === 1) {
      return dados[0];
    }

    if (dados.length === 2) {
      return dados.join(' e ');
    }

    const ultimoElemento = dados.pop();
    return `${dados.join(', ')} e ${ultimoElemento}`;
  }

  /**
   * Convert o arquivo de base64 em BlobData (funciona para os formatos pdf, jpg, jpg e png)
   * @param base64 Arquivo em Base64
   * @param extensao Formato do arquivo
   */
  static base64toBlob(base64: string, extensao: string): Blob {
    const type = this.getMimeTypeFromExtensao(extensao);
    const byteArrays = this.decodeBase64ToUint8Arrays(base64, 512);

    return new Blob(byteArrays, { type });
  }

  private static getMimeTypeFromExtensao(extensao: string): string {
    const mimeTypesByExtensao: Record<string, string> = {
      [FormatoArquivo.PDF]: 'application/pdf',
      [FormatoArquivo.JPG]: 'image/jpg',
      [FormatoArquivo.JPEG]: 'image/jpeg',
      [FormatoArquivo.PNG]: 'image/png',
    };

    return mimeTypesByExtensao[extensao.toLowerCase()] ?? '';
  }

  private static decodeBase64ToUint8Arrays(base64: string, sliceSize: number): any[] {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return byteArrays;
  }

  static baixarArquivoPeloId(arquivo:any, arquivoService: ArquivoService, isRh = false) {
    const id = arquivo.arquivoId ?? arquivo.id;
    const func = isRh ? arquivoService.downloadRh(id) : arquivoService.download(id);
    func.subscribe({
      next: (responseArquivo:any) => {
        const blob = new Blob([responseArquivo.body], { type: `application/${arquivo.extensao}` });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${arquivo.nomeOriginal ?? arquivo.nome}.${arquivo.extensao}`;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    });
  }

  static baixarArquivoComBase64(arquivo: any) {
    const blobFile = this.base64toBlob(arquivo.base64, arquivo.extensao);
    const url = window.URL.createObjectURL(blobFile);
    const tagAnchor = document.createElement('a');
    tagAnchor.href = url;
    tagAnchor.download = `${arquivo.nome}.${arquivo.extensao}`;
    tagAnchor.click();
    window.URL.revokeObjectURL(url);
  }

  static mediaMinima(): number {
    const storageService = new StorageService();
    const anoLetivo = Number(storageService.getAnoLetivo());
    return anoLetivo < 2025 ? 7 : 6;
  }

  static formatarPorcentagemDuasCasasDecimais(porcentagem: any) {
    if (porcentagem) {
      const valorComPonto = porcentagem.toString().replaceAll(',', '.');
      const porcentagemFormatada = parseFloat(valorComPonto);
      return porcentagemFormatada.toFixed(2)?.replace('.', ',');
    }
  }

  static formatarNotaUmaCasaDecimal(nota: any) {
    if (nota) {
      const notaFormatada = parseFloat(nota);
      return notaFormatada.toFixed(1)?.replace('.', ',');
    }
  }

  static downloadFileXlsx(response: any, name: string, exibirData = true) {
    if (exibirData) {
      name = `${name}_${moment().format('DD-MM-yyyy')}.xlsx`.replace(/\s/g, '-');
    } else {
      name = `${name}.xlsx`.replace(/\s/g, '-');
    }
    const blob = new Blob([response.body], {
      type: 'application/vnd.ms-excel;charset=utf-8',
    });
    saveAs(blob, name);
  }

  static async getImageFromChart(chartElement: HTMLElement, size: number = 1300): Promise<string> {
    let img: any;

    return html2canvas(chartElement, {
      width: size,
      scale: 2,
      useCORS: true,
      allowTaint: true,
    }).then((canvas) => {
      img = canvas.toDataURL('image/png', 1.0);
      return img;
    });
  }

  static aplicarMascaraTelefone(telefone: string): string {
    const numero = (telefone || '').replace(/\D/g, '');
    if (!numero) return '';

    let telefoneComMascara = '';

    const ddd = numero.slice(0, 2);

    if (numero.length <= 2) {
      telefoneComMascara = `(${numero}`;
    } else if (numero.length <= 6) {
      telefoneComMascara = `(${ddd}) ${numero.slice(2)}`;
    } else if (numero.length === 11) {
      const verificador = numero.slice(2, 3);
      const parte1 = numero.slice(3, 7);
      const parte2 = numero.slice(7);
      telefoneComMascara = `(${ddd}) ${verificador} ${parte1}-${parte2}`;
    } else {
      const parte1 = numero.slice(2, 6);
      const parte2 = numero.slice(6);
      telefoneComMascara = `(${ddd}) ${parte1}-${parte2}`;
    }

    return telefoneComMascara;
  }

  static dataFormatadaApenasData(date: string) {
    if (!date) return '';
    return moment(date).format('DD/MM/YYYY');
  }

  static dataFormatadaComTempo(date: string) {
    if (!date) return '';
    return moment(date).format('DD/MM/YYYY HH:mm');
  }

  public static getDataReadaptacaoFormatada(model): string {
    if(model.dataInicio == null) return 'Não Possui';

    return model.dataInicio && model.dataFim == null ?
    `${Util.dataFormatadaApenasData(model.dataInicio)}` :
    `${Util.dataFormatadaApenasData(model.dataInicio)} - ${Util.dataFormatadaApenasData(model.dataFim)}`;
  }

  static formatarCPF(cpf: string): string {
    if (cpf) {
      cpf = cpf.replace(/\D/g, '');
      cpf = cpf.padStart(11, '0');
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    return '-';
  }

  static toLocalISOString(date = new Date()): string {
    const offset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - offset)
      .toISOString()
      .slice(0, -1);
  }

  /**
   * Calcula a diferença entre duas datas em dias e retorna uma string formatada
   * @param dataInicio - Data inicial (objeto Date ou string)
   * @param dataFim - Data final (objeto Date ou string)
   * @param incluirDiaFinal - Se deve incluir o dia final na contagem (padrão: true)
   * @returns String formatada com o número de dias (ex: "5 dias" ou "1 dia")
   */
  public static calcularQuantidadeDeDiasNoPeriodo(
    dataInicio: Date | string,
    dataFim: Date | string
  ): string {
    if (!dataInicio || !dataFim) {
      return null;
    }

    const startDate = dataInicio instanceof Date ? dataInicio : new Date(dataInicio);
    const endDate = dataFim instanceof Date ? dataFim : new Date(dataFim);

    const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    const totalDays = diffDays + 1;
    const label = totalDays === 1 ? 'dia' : 'dias';

    return `${totalDays} ${label}`;
  }

  /**
   * Formata uma data para o formato local brasileiro (DD/MM/YYYY HH:mm)
   * @param data - Data em formato string
   * @returns Data formatada como string
   */
  static formatDateToLocal(data: string): string {
    if (!data) return '';

    let date: Date;

    // Caso ISO (2025-12-10T21:07:15.441Z)
    if (/^\d{4}-\d{2}-\d{2}T/.test(data)) {
      date = new Date(data);
    }
    // Caso pt-BR (10/12/2025, 21:05:00)
    else if (/^\d{2}\/\d{2}\/\d{4},/.test(data)) {
      // Extrai partes
      const [datePart, timePart] = data.split(',');
      const [day, month, year] = datePart.trim().split('/');
      const [hour, minute, second] = timePart.trim().split(':');
      // Cria data em UTC
      date = new Date(
        Number(year),
        Number(month) - 1,
        Number(day),
        Number(hour),
        Number(minute),
        Number(second) || 0
      );
      // Ajusta para UTC-3 (Brasília)
      date.setHours(date.getHours() - 3);
    } else {
      // fallback
      date = new Date(data);
    }

    // Formata para 'DD/MM/YYYY HH:mm'
    return date
      .toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
      .replace(',', '');
  }
}
